import CardKey from "./cardKey";
import { typographier } from "../../utils/typography/typographier";
const SvgLink = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z"
      fill="#currentColor"
    />
  </svg>
);
function CardMobile4({ numberKey }) {
  // Vérification pour s'assurer que numberKey existe et est correctement structuré
  if (!numberKey) {
    return <div>Loading...</div>;
  }

  const { title, cards = [], description1, description2 } = numberKey;

  return (
    //Ex cardQuinaryy
    <div className="cardQuaternary">
      <div className="cardQuaternary-container1">
        <h2 className="cardQuaternary-container1-title">{title}</h2>
      </div>
      <div className="cardQuaternary-container1">
        {cards.length > 0 ? (
          cards.map(card => <CardKey key={card.id || card.key} dataElement={card} />)
        ) : (
          <p>Aucune carte disponible.</p>
        )}
      </div>
      <div className="cardQuaternary-container1">
        <a
          className="cardQuaternary-container1-links"
          href="https://www.harmonie-mutuelle.fr/marque/sengager-aupres-des-entreprises/observatoire-sante/barometre-2023-sport-en-entreprise"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={description1}
        >
          <div className="cardQuaternary-container1-links-containerSvg">
            <SvgLink className="cardQuaternary-container1-links-containerSvg-svg" />
          </div>
          <div className="cardQuaternary-container1-links-link">{typographier(description1)}</div>
        </a>
        <a
          className="cardQuaternary-container1-links"
          href="https://ffse.fr/ffse/presentation/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={description2}
        >
          <div className="cardQuaternary-container1-links-containerSvg">
            <SvgLink className="cardQuaternary-container1-links-containerSvg-svg" />
          </div>
          <div className="cardQuaternary-container1-links-link">{typographier(description2)}</div>
        </a>
      </div>
    </div>
  );
}

export default CardMobile4;
